import { Route } from 'react-router-dom'
import AccountsSettingsScreen from 'screens/AccountsSettings/AccountSettingsView'
import ConsentTemplateView from 'screens/AccountsSettings/ConsentTemplates/ConsentTemplateView'
import FamilySettingsScreen from 'screens/AccountsSettings/FamilySettings'
import FamilyInviteScreen from 'screens/AccountsSettings/FamilySettings/FamilyInviteScreen'
import HomeSettingsScreen from 'screens/AccountsSettings/HomeSettings/HomeSettingsFeatureFlagWrapper'
import MemberBenefits from 'screens/AccountsSettings/MemberBenefits'
import SkillNeedTemplateScreen from 'screens/AccountsSettings/SkillsAndNeeds/SkillNeedTemplateScreen'
import ZonesScreen from 'screens/AccountsSettings/Zones'
import BillingScreen from 'screens/AccountsSettings/Billing'
import ConsentTemplateLibrary from 'screens/AccountsSettings/ConsentTemplates'
import { PrivacyOfficersScreen } from 'screens/AccountsSettings'

import { ID } from './utils'
import MonitoringReportSettingsScreen from 'screens/AccountsSettings/MonitoringReportSettings/MonitoringReportSettingsScreen'
import IncidentReportSettingsScreen from 'screens/AccountsSettings/IncidentReportsSettings/IncidentReportsSettingsScreen'
import CarePackageSettingsScreen from 'screens/Rostering/siteSettings/CarePackageSettings'
import ContractsAndAbsenceSettingsScreen from 'screens/Rostering/siteSettings/ContractsAndAbsenceSettings'
import RotaPatternsSettings from 'screens/Rostering/siteSettings/RotaPatternsSettings'
import WarningsSettingsScreen from 'screens/Rostering/siteSettings/WarningsSettings'
import TravelTimeAndMileageSettingsScreen from 'screens/Rostering/siteSettings/TravelTimeAndMileageSettings'

const SETTINGS_PATH = 'settings'
const BILLING = 'billing'
const HOME_SETTINGS = `home-${SETTINGS_PATH}`
const FAMILY_SETTINGS = `family-${SETTINGS_PATH}`
const FAMILY_INVITE = 'family-invite'
const ZONES = 'zones'
const MONITORING_REPORTS = 'monitoring-report-settings'
const INCIDENT_REPORTS = 'incident-reports-settings'
const PERKS = 'perks'
const CONSENT_TEMPLATES = 'consent-templates'
const SKILLS_AND_NEEDS = 'skills-and-needs'
const PRIVACY_OFFICERS = 'privacy-officers'
const CARE_PACKAGE = 'care-package'
const CONTRACTS_AND_ABSENCES = 'contracts-and-absences'
const WARNINGS = 'warnings'
const ROTA_PATTERNS = 'rota-patterns'
const TRAVEL_TIME_AND_MILEAGE = 'travel-time-and-mileage'
export const SETTINGS = {
  INDEX: `${SETTINGS_PATH}`,
  BILLING: `${SETTINGS_PATH}/${BILLING}`,
  HOME_SETTINGS: `${SETTINGS_PATH}/${HOME_SETTINGS}`,
  FAMILY_SETTINGS: `${SETTINGS_PATH}/${FAMILY_SETTINGS}`,
  FAMILY_INVITE: `${SETTINGS_PATH}/${FAMILY_INVITE}`,
  ZONES: `${SETTINGS_PATH}/zones`,
  PERKS: `${SETTINGS_PATH}/perks`,
  CONSENT_TEMPLATES: `${SETTINGS_PATH}/${CONSENT_TEMPLATES}`,
  CONSENT_TEMPLATE_ID: `${SETTINGS_PATH}/${CONSENT_TEMPLATES}/${ID}`,
  SKILLS_AND_NEEDS: `${SETTINGS_PATH}/${SKILLS_AND_NEEDS}`,
  PRIVACY_OFFICERS: `${SETTINGS_PATH}/${PRIVACY_OFFICERS}`,
  CARE_PACKAGE: `${SETTINGS_PATH}/${CARE_PACKAGE}`,
  CONTRACTS_AND_ABSENCES: `${SETTINGS_PATH}/${CONTRACTS_AND_ABSENCES}`,
  WARNINGS: `${SETTINGS_PATH}/${WARNINGS}`,
  ROTA_PATTERNS: `${SETTINGS_PATH}/${ROTA_PATTERNS}`,
  TRAVEL_TIME_AND_MILEAGE: `${SETTINGS_PATH}/${TRAVEL_TIME_AND_MILEAGE}`,
}

export const settingsRoutes = (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <Route path={SETTINGS_PATH} element={<AccountsSettingsScreen />}>
    <Route path={BILLING} element={<BillingScreen />} />
    <Route path={HOME_SETTINGS} element={<HomeSettingsScreen />} />
    <Route path={INCIDENT_REPORTS} element={<IncidentReportSettingsScreen />} />
    <Route path={FAMILY_SETTINGS} element={<FamilySettingsScreen />} />
    <Route path={FAMILY_INVITE} element={<FamilyInviteScreen />} />
    <Route path={ZONES} element={<ZonesScreen />} />
    <Route
      path={MONITORING_REPORTS}
      element={<MonitoringReportSettingsScreen />}
    />
    <Route path={CARE_PACKAGE} element={<CarePackageSettingsScreen />} />
    <Route
      path={CONTRACTS_AND_ABSENCES}
      element={<ContractsAndAbsenceSettingsScreen />}
    />
    <Route path={WARNINGS} element={<WarningsSettingsScreen />} />
    <Route path={ROTA_PATTERNS} element={<RotaPatternsSettings />} />
    <Route
      path={TRAVEL_TIME_AND_MILEAGE}
      element={<TravelTimeAndMileageSettingsScreen />}
    />
    <Route path={PERKS} element={<MemberBenefits />} />
    <Route path={CONSENT_TEMPLATES} element={<ConsentTemplateLibrary />} />
    <Route
      path={`${CONSENT_TEMPLATES}/${ID}`}
      element={<ConsentTemplateView />}
    />
    <Route path={SKILLS_AND_NEEDS} element={<SkillNeedTemplateScreen />} />
    <Route path={PRIVACY_OFFICERS} element={<PrivacyOfficersScreen />} />
  </Route>
)
